import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/Header';
import SignIn from './components/SignIn';
import AddUserPage from './pages/AddUserPage';
import LeadsListPage from './pages/LeadsListPage';
import UserConversation from './components/UserConversation';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';
import LeadFormPage from './pages/LeadFormPage';
import ClientDashboard from './pages/ClientDashboard';
import OrganizationFormPage from './pages/OrganizationFormPage';
import ProjectFormPage from './pages/ProjectFormPage';
import OnboardingPage from './pages/OnboardingPage';
import ProjectListPage from './pages/ProjectListPage';
import OrganizationListPage from './pages/OrganizationListPage';
import UserListPage from './pages/UserListPage';
import BotListPage from './pages/BotListPage';
import BotOnboardingFormPage from './pages/AddBotFormPage';
import CreditPage from './pages/CreditPage';
import PointsDeductionConfigPage from './pages/RuleCreditPage';
import WhatsAppBusinessPage from './pages/WhatsAppBusinessPage';
import ChatBot from './components/Chatbot';
import UploadCSV from './pages/UploadCSVPage';


function App() {
  const { isLoggedIn } = useAuth();
  return (
    <Router>
      <div className="App">
       <Header />
        <Routes>
          <Route path="/" element={isLoggedIn ? <LeadsListPage /> : <Navigate to="/signin" />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/users" element={<UserListPage />} />
          <Route path="/users/new" element={<AddUserPage />} />
          <Route path="/users/:id/conversations" element={<UserConversation />} />
          <Route path="/organizations" element={<OrganizationListPage />} />
          <Route path="/organizations/new" element={<OrganizationFormPage />} />
          <Route path="/projects" element={<ProjectListPage />} />
          <Route path="/projects/new" element={<ProjectFormPage />} />
          <Route path="/leads/new" element={<LeadFormPage />} />
          <Route path="/clients/dashboard" element={<ClientDashboard />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/bots" element={<BotListPage />} />
          <Route path="/bots/new" element={<BotOnboardingFormPage />} />
          <Route path="/credits/new" element={<CreditPage />} />
          <Route path="/rules" element={<PointsDeductionConfigPage />} />
          <Route path="/whatsapp" element={<WhatsAppBusinessPage />} />
          <Route path="/chatbot/:theme/:project_id" element={<ChatBot />} />
          <Route path="/UploadCSV" element={<UploadCSV />} />
        </Routes>
      </div>
    </Router>
  );
}

const AppWithAuth = () => {
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  );
};

export default AppWithAuth;
